import * as React from 'react';

import Link, { LinkProps } from '../link';
import Icon, { IconTypes, IconColors } from '../icon';
import {
	Content,
	IconLayout
} from './styled';


type IconLinkProps = {
	leftIconType?: keyof IconTypes;
	rightIconType?: keyof IconTypes;
	iconColor?: IconColors;
	iconSize?: number;
} & LinkProps;

const IconLink: React.SFC<IconLinkProps> = (props) => {
	const {
		leftIconType,
		rightIconType,
		iconColor,
		iconSize,
		children,
		...rest
	} = props;

	return (
		<Link
			{...rest}>
			<Content>
				{
					leftIconType
					&& <IconLayout marginRight={4}>
							<Icon type={leftIconType} color={iconColor} width={iconSize} height={iconSize} />
						</IconLayout>
				}
				<span>{children}</span>
				{
					rightIconType
					&& <IconLayout marginLeft={4}>
							<Icon type={rightIconType} color={iconColor} width={iconSize} height={iconSize} />
						</IconLayout>
				}
			</Content>
		</Link>
	);
}

IconLink.displayName = 'IconLink';
IconLink.defaultProps = {
	iconColor: 'primary',
	iconSize: 14,
};

export default IconLink;
